














  import { Component, Vue, Provide, Watch } from "vue-property-decorator";
//   import automatiCall from "./components/automatiCall.vue";
  const phoneSale = () => import("./components/phoneSale.vue");
  const saleRecord = () => import("./components/saleRecord.vue");

  import { timeFormat } from "@/utils";
  import {  GetOverdueCaseReq,  GetRemindCaseReq } from "@/pbjs/xcommon/collection_pb.js";
  import { collectionServiceClient } from "@/api";
  import { setCommon, errorMsg } from "@/utils/request";
  import { Options, CaseLogOptions } from "@/request/getAllAutoCallResult";
  @Component({
    name: "orderDeal",
    // components: { phoneSale, saleRecord,automatiCall }
    components: { phoneSale, saleRecord }

  })
  export default class CombinationProperty extends Vue {
    @Provide() private supplieOptions:any = [];
    @Provide() private activeName: string = "first";
    @Provide() private tableData: any = [{ opUid: 123, phoneObject: 22 }];
    @Provide() private autoCallData: any = [];
    @Provide() private isdial: any ;
    
    @Provide() private pageIndex: number = 1;
    @Provide() private pageSize: number = 20;
    @Provide() private pagerCount: number = 0;
    @Provide() private urgebase: any; // 工单详情依赖的数据
    @Provide() private mobileNum: string = ""; //  获取自动外呼所需的参数
    @Provide() private caseId: number = 0;
    @Provide() private itemId: number = 0;
    @Provide() private orderId: string = "";


    private changeTitle (){
        this.activeName = 'second'
    }
  }
